import { CockpitRow } from "./cockpitDesigner.models";
import { ElementProperties } from "./designerCSSPropertiesForm/designerCSSPropertiesForm";

export const defaultRowElementProperties:ElementProperties = {
     width: 320,
     height: 200,
     lockAspectRatio: false,
     columns: 2,
     gap: 16,
     marginTop: 0,
     marginRight: 0,
     marginBottom: 0,
     marginLeft: 20,
     paddingTop: 0,
     paddingRight: 0,
     paddingBottom: 0,
     paddingLeft: 0,
     backgroundColor: '#ffffff',
     opacity: 100,
     borderRadius: 0,
}

export const defaultRow:CockpitRow = {
   id: 'defaultid',
   height: 100,
   columns: [],
   properties: defaultRowElementProperties
}


